import Products from "../components/Products/Products";
import React, { Fragment } from "react";

const ProductsPage = () => {
  return (
    <Fragment>
      <Products />
    </Fragment>
  );
};

export default ProductsPage;
